import { createSelector } from "reselect";
import moment from "moment";
import _ from "lodash";
const colours = [
    "239, 83, 80",
    "236, 64, 122",
    "171, 70, 187",
    "126, 87, 194",
    "92, 107, 192",
    "66, 165, 245",
    "40, 182, 246",
    "37, 197, 218",
    "38, 166, 154",
    "102, 187, 106",
    "156, 204, 101",
    "212, 225, 87",
    "255, 238, 88",
    "255, 201, 40",
    "255, 167, 37",
    "255, 112, 67",
];
export const selectWeekCount = ({ WeekPlannerV2_reducer }) => {
    return WeekPlannerV2_reducer.weekCount;
};
export const selectColors = () => {
    return colours;
};

export const selectWeekStart = ({ WeekPlannerV2_reducer }) => {
    return WeekPlannerV2_reducer.weekStart;
};
export const selectDepartments = ({ WeekPlannerV2_reducer }) => {
    return WeekPlannerV2_reducer.departments;
};
export const selectAreas = ({ WeekPlannerV2_reducer }) => {
    return WeekPlannerV2_reducer.areas;
};
export const selectAreaFilter = ({ WeekPlannerV2_reducer }) => {
    return WeekPlannerV2_reducer.selected_area;
};
export const selectDepartmentFilter = ({ WeekPlannerV2_reducer }) => {
    return WeekPlannerV2_reducer.selected_department;
};
export const selectCopyPasteEvent = ({ WeekPlannerV2_reducer }) => {
    return WeekPlannerV2_reducer.copyPasteEvent;
};

export const selectIsLocked = ({ WeekPlannerV2_reducer }) => {
    return WeekPlannerV2_reducer.isLocked;
};
export const selectPlannerDetails = ({ WeekPlannerV2_reducer }) => {
    return WeekPlannerV2_reducer.plannerDetails;
};
export const selectUsers = ({ WeekPlannerV2_reducer }) => {
    return WeekPlannerV2_reducer.users;
};

export const selectVehicles = ({ WeekPlannerV2_reducer }) => {
    if (WeekPlannerV2_reducer.vehicles) return WeekPlannerV2_reducer.vehicles;
    else return false;
};
export const selectEquipment = ({ WeekPlannerV2_reducer }) => {
    if (WeekPlannerV2_reducer.equipment) return WeekPlannerV2_reducer.equipment;
    else return false;
};
export const selectRawJobpostings = ({ WeekPlannerV2_reducer }) => {
    if (WeekPlannerV2_reducer.rawJobpostings) {
        let jps = WeekPlannerV2_reducer.rawJobpostings;
        let rawJobpostings = {};
        Object.keys(jps).map((y) => {
            Object.keys(jps[y]).map((m) => {
                Object.keys(jps[y][m]).map((ts) => {
                    _.assign(rawJobpostings, { [ts]: jps[y][m][ts] });
                    return null;
                });
                return null;
            });
            return null;
        });

        return rawJobpostings;
    } else return false;
};

export const selectArrangedJobpostingsFromStore = ({
    WeekPlannerV2_reducer,
}) => {
    return WeekPlannerV2_reducer.arrangedJobpostings;
};

export const selectClickedEventSegment = ({ WeekPlannerV2_reducer }) => {
    return WeekPlannerV2_reducer.clickedEventSegment;
};

export const selectSelectedJobpostingID = ({ WeekPlannerV2_reducer }) => {
    return WeekPlannerV2_reducer.selectedJobpostingID;
};
export const selectTrackID = ({ WeekPlannerV2_reducer }) => {
    return WeekPlannerV2_reducer.trackID;
};
export const selectProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) return UserProfile_reducer.profile.profile;
    else return false;
};export const selectConfig = ({ MainReducer }) => {
    if (MainReducer.config) return MainReducer.config;
    else return false;
};
export const selectPermissions = createSelector(
    [selectConfig, selectProfile],
    (config = false, { access_level = false }) => {
        if (access_level && config) {
            return config[access_level]["roster"];
        } else return false;
    }
);
export const canRead = createSelector([selectPermissions], (config = false) => {
    return config ? config.read : true;
});
export const canUpdate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.update : true;
    }
);
export const canCreate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.create : true;
    }
);
export const canDelete = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.delete : true;
    }
);
export const selectEquipmentInfo = createSelector(
    [selectEquipment],
    (equipment = false) => {
        if (equipment) {
            let equipInfo = _.compact(
                Object.keys(equipment).map((e) => {
                    let uid = _.get(equipment[e], "profile.uid") || "N/A";
                    let description =
                        _.get(equipment[e], "profile.description") || "N/A";
                    let name = _.get(equipment[e], "profile.name") || "N/A";
                    let status = _.get(equipment[e], "profile.status") || "N/A";
                    let timestamp =
                        _.get(equipment[e], "profile.timestamp") || "N/A";
                    return {
                        uid,
                        description,
                        name,
                        status,
                        timestamp,
                    };
                })
            );
            return equipInfo;
        } else return false;
    }
);
export const selectVehicleInfo = createSelector(
    [selectVehicles],
    (vechicles = false) => {
        if (vechicles) {
            let vecInfo = _.compact(
                Object.keys(vechicles).map((e) => {
                    let machine_reg =
                        _.get(vechicles[e], "profile.machine_reg") || "N/A";
                    let machine_tax_expiry =
                        _.get(vechicles[e], "profile.machine_tax_expiry") ||
                        "N/A";
                    let machine_status =
                        _.get(vechicles[e], "profile.machine_status") || "N/A";
                    let machine_nct_expiry =
                        _.get(vechicles[e], "profile.machine_nct_expiry") ||
                        "N/A";
                    let machine_desc =
                        _.get(vechicles[e], "profile.machine_desc") || "N/A";
                    return {
                        machine_reg,
                        machine_tax_expiry,
                        machine_status,
                        machine_nct_expiry,
                        machine_desc,
                    };
                })
            );
            return vecInfo;
        } else return false;
    }
);
export const selectUserInfo = createSelector([selectUsers], (users = false) => {
    if (users) {
        let userInfo = _.compact(
            Object.keys(users).map((e) => {
                let uid = e;
                let fname = _.get(users[e], "profile.first_name") || "N/A";
                let lname = _.get(users[e], "profile.last_name") || "N/A";
                let departments =
                    _.get(users[e], "profile.departments") || false;
                let areas = _.get(users[e], "profile.areas") || false;
                let deleted = _.get(users[e], "profile.deleted") || false;
                if (!deleted) {
                    return {
                        uid,
                        user_name: `${fname} ${lname}`,
                        areas,
                        departments,
                    };
                } else return null;
            })
        );
        return userInfo.sort((a, b) => a.user_name.localeCompare(b.user_name));
    } else return false;
});
export const selectTracks = createSelector(
    [selectPlannerDetails, selectDepartmentFilter, selectAreaFilter],
    (planner, department, area) => {
        if (planner) {
            let { tracks = false } = planner;
            if (tracks) {
                tracks = Object.keys(tracks).map((e) => {
                    return tracks[e];
                });

                if (department !== "all_departments") {
                    tracks = _.compact(
                        tracks.map((e) => {
                            if (!e.department) return e;
                            else if (e.department === department) return e;
                            return null;
                        })
                    );
                }

                if (area !== "all_areas") {
                    tracks = _.compact(
                        tracks.map((e) => {
                            if (!e.area) return e;
                            else if (e.area === area) return e;
                            return null;
                        })
                    );
                }

                return tracks;
            } else return false;
        } else return false;
    }
);
export const selectEvents = createSelector(
    [selectPlannerDetails],
    (planner) => {
        if (planner) {
            let { events = false } = planner;
            return events;
        } else return false;
    }
);
export const selectWeekDayStrings = createSelector(
    [selectWeekStart, selectWeekCount],
    (weekStart, weekCount) => {
        const weekDays = [];

        for (let i = 0; i < weekCount * 7; ++i) {
            const date = moment(weekStart).add(i, "days");
            const dateString = date.format("ddd Do MMM");
            weekDays.push(dateString);
        }

        return weekDays;
    }
);

export const selectNextWeekStart = createSelector(
    [selectWeekStart],
    (weekStart) => {
        const nextWeekStart = moment(weekStart).add(1, "week").toDate();
        return nextWeekStart;
    }
);

export const selectPreviousWeekStart = createSelector(
    [selectWeekStart],
    (weekStart) => {
        const previousWeekStart = moment(weekStart).add(-1, "week").toDate();
        return previousWeekStart;
    }
);

export const getMomentFromDateString = (dateString) => {
    return moment(dateString, "DD-MM-YYYY");
};

export const getDateStringFromMoment = (momentObject) => {
    return momentObject.format("DD-MM-YYYY").toString();
};

// function getJobpostingCellPositions(rowCount, weekCount, dayArray) {
//     const rowsArray = JSON.parse(
//         JSON.stringify(
//             new Array(rowCount).fill(new Array(weekCount * 7).fill(false))
//         )
//     );

//     for (let row = 0; row < rowCount; ++row) {
//         let candidateIndex = false;
//         let startingIndex = false;
//         let pushDown = [];

//         for (let i = 0; i < dayArray.length; ++i) {
//             if (
//                 dayArray[i].length > 0 &&
//                 typeof dayArray[i][row] !== "undefined"
//             ) {
//                 candidateIndex = dayArray[i][row];
//                 startingIndex = i;

//                 if (candidateIndex !== false && startingIndex !== false) {
//                     for (let i = 0; i < dayArray.length; ++i) {
//                         if (dayArray[i].length > row + 1) {
//                             if (dayArray[i][row + 1] === candidateIndex) {
//                                 pushDown.push(candidateIndex);
//                             }
//                         }
//                     }
//                 }
//             } else if (dayArray[i].length === 0) {
//                 dayArray[i] = new Array(rowCount).fill(false);
//             }
//         }

//         pushDown = [...new Set(pushDown)];

//         for (let i = 0; i < dayArray.length; ++i) {
//             for (let j = 0; j < pushDown.length; ++j) {
//                 const pushDownIndex = pushDown[j];

//                 if (
//                     dayArray[i][row] === pushDownIndex &&
//                     Array.isArray(dayArray[i])
//                 ) {
//                     dayArray[i].splice(row, 0, false);
//                 }
//             }
//         }
//     }

//     for (let i = 0; i < rowsArray.length; ++i) {
//         for (let j = 0; j < rowsArray[i].length; ++j) {
//             if (typeof dayArray[j][i] !== "undefined") {
//                 rowsArray[i][j] = dayArray[j][i];
//             } else {
//                 rowsArray[i][j] = false;
//             }
//         }
//     }

//     return rowsArray;
// }

export const selectArrangedJobpostingsFromRawJobpostings = createSelector(
    [selectEvents, selectWeekStart, selectWeekCount, selectTrackID],
    (rawJobpostings = false, weekStart, weekCount, tid = false) => {
        if (
            // tid === false ||
            rawJobpostings === false ||
            typeof rawJobpostings === "undefined" ||
            rawJobpostings === null
        ) {
            return [];
        }

        const jobpostings = _.compact(
            Object.entries(rawJobpostings).map(([key, value]) => {
                return {
                    uid: key,
                    track_id: _.get(value, "track_id") || null,
                    s_start_date: _.get(value, "start_date") || null,
                    s_end_date: _.get(value, "end_date") || null,
                    start_date: moment(
                        _.get(value, "start_date") || null,
                        "DD-MM-YYYY"
                    ),
                    end_date: moment(
                        _.get(value, "end_date") || null,
                        "DD-MM-YYYY"
                    ),
                };
            })
        );

        const weekStartMoment = moment(weekStart);
        const dayArray = [];
        let rowCount = 0;
        for (let i = 0; i < weekCount * 7; ++i) {
            dayArray.push([]);
            const currentDay = moment(weekStartMoment).add(i, "days");
            for (let jp = 0; jp < jobpostings.length; jp++) {
                const { start_date, end_date } = jobpostings[jp];

                if (currentDay >= start_date && currentDay <= end_date) {
                    dayArray[i].push(jp);

                    if (dayArray[i].length > rowCount) {
                        rowCount = dayArray[i].length;
                    }
                }
            }
        }

        if (rowCount === 0) {
            return [];
        }
        let jobpostingIndices = {};
        jobpostings.map((job, i) => {
            let start = -1;
            let end = -1;
            dayArray.map((day, d) => {
                if (day.includes(i) && start === -1) {
                    start = d;
                } else if (day.includes(i) && start !== -1) {
                    end = d;
                }
                return null;
            });
            if (end === -1) end = start;
            if (start !== -1 && end !== -1)
                jobpostingIndices = _.assign(jobpostingIndices, {
                    [i]: {
                        startIndex: start,
                        endIndex: end,
                    },
                });
            return null;
        });

        let result = Object.keys(jobpostingIndices).reduce((acc, curr) => {
            acc[jobpostings[curr].uid] = jobpostingIndices[curr];
            return acc;
        }, {});

        result = Object.keys(result).reduce((acc, curr) => {
            const startDate = _.get(rawJobpostings[curr], "start_date");
            const endDate = _.get(rawJobpostings[curr], "end_date");
            const track_id = _.get(rawJobpostings[curr], "track_id");
            const name = _.get(rawJobpostings[curr], "name");

            const startDiff = getMomentFromDateString(startDate).diff(
                weekStartMoment,
                "days"
            );
            const endDiff = getMomentFromDateString(endDate).diff(
                weekStartMoment,
                "days"
            );

            acc[curr] = {
                ...result[curr],
                startIndex: startDiff,
                endIndex: endDiff,
                track_id,
                name,
            };

            return acc;
        }, {});

        return result;
    }
);

export const selectRowCount = createSelector(
    [selectArrangedJobpostingsFromStore, selectWeekCount],
    (arrangedJobpostings = false, weekCount) => {
        const arrangedJobpostingsArray = Object.entries(
            arrangedJobpostings
        ).map(([key, value]) => ({
            key,
            ...value,
        }));
        const rowCounts = [];
        for (let i = 0; i < weekCount * 7; ++i) {
            let currentRowCount = 0;
            for (let jp = 0; jp < arrangedJobpostingsArray.length; ++jp) {
                currentRowCount++;
            }

            rowCounts.push(currentRowCount);
        }

        let rowCount = 0;

        arrangedJobpostingsArray.map(({ row }) => {
            if (row > rowCount) {
                rowCount = row;
            }

            return null;
        });

        rowCount++;

        rowCounts.map((e) => {
            if (e > rowCount) {
                rowCount = e;
            }

            return null;
        });

        return rowCount;
    }
);

export const selectArrangedJobpostingsAsArray = createSelector(
    [selectArrangedJobpostingsFromStore],
    (arrangedJobpostings) => {
        return Object.keys(arrangedJobpostings).map((e) => {
            const int = parseInt(e);
            const colour = colours[int % colours.length];
            return {
                uid: e,
                ...arrangedJobpostings[e],
                colour,
            };
        });
    }
);

export const selectSelectedJobpostingProfile = createSelector(
    [selectSelectedJobpostingID, selectRawJobpostings],
    (jobpostingID, rawJobpostings) => {
        return _.get(rawJobpostings, `${jobpostingID}.profile`) || false;
    }
);

export const selectJobpostingProfile = (jobpostingID) =>
    createSelector([selectRawJobpostings], (rawJobpostings) => {
        return _.get(rawJobpostings, `${jobpostingID}.profile`) || false;
    });
